import React, {useRef, useState, useEffect, useLayoutEffect} from 'react';
import {NavLink, useNavigate, useLocation} from 'react-router-dom';
import engFlag from './../../../assets/images/eng-lang.svg';
import arbFlag from './../../../assets/images/arb-lang.svg';
import { Button } from 'react-bootstrap';
import './../../../translations/i18n';
import { useTranslation } from 'react-i18next';
//for redux
import { useDispatch, useSelector } from 'react-redux';
import { SET_LANGUAGE, loggedinUserInfo } from '../../../store/slices/UserSlice';
import { defaultCompanyServiceLink } from '../../../utils/helper';
import AOS from 'aos';
// import { changeLanguage } from '../../../util/languageChange';
const HomeHeader = (params) => {
	const mustanadlogo = `${process.env.REACT_APP_CDN_PATH}/public/mustanad-logo.svg`;
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { t, i18n } = useTranslation();
	const language = useSelector((state) => state.user.language);
	const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
	const user_info = useSelector(loggedinUserInfo); //for redux EX:- user_info: loggedinUserData
	const services = useSelector((state) => state.services);
	const [menushow, setmenuShow] = useState();
	const [redirectLink, setRedirectLink] = useState('/');
	let activeClassName = 'active';
	/**Get current path in route */
	const { pathname } = useLocation();
	const pageArray = ['auditing', 'zakat-tax', 'accounting','local-content-auditing'];
	const pageType = pathname?.split('/').pop();
	/**Language change function */
	const languageChange = (lang) => {
		document.body.classList.add('langChange');
		const className = 'ar' === language ? 'ar' : 'en';
		document.body.classList.add(className);
		let url = window.location.pathname;
		url = url.replace('/' + language, '/' + lang);
		i18n.changeLanguage(lang);
		dispatch(SET_LANGUAGE(lang)); //redux
		navigate(url);
		window.location.href = url;
	};

	
	useEffect(() => {
		if (isLoggedIn) {
			setRedirectLink( defaultCompanyServiceLink( {users :user_info, services: services?.service_info},language));
		};
		AOS.init({duration:1000,easing:'ease-in-out',once:true});
	},[]);





	const ref = useRef();
	const sticky = useStickyHeader( 100 );
	const headerClasses = `mainheader${(sticky) ? ' sticky' : ''}`
	const { clientHeight } = ref;

	function useStickyHeader(offset = 0) {
		const [stick, setStick] = useState(false);
		
		const handleScroll = () => {
		  setStick( window.scrollY > offset );
		};
		
		useLayoutEffect(() => {
		  window.addEventListener('scroll', handleScroll);
		  
		  return(() => {
			window.removeEventListener('scroll', handleScroll);
		  });
		});
		
		return stick;
	  }




	
	return (
		<>
			<header ref={ref} className={ headerClasses } data-aos="fade">
				<div className="wrapper">
					<div className="d-flex justify-content-between align-items-center">
						<section className="logopnl">
							<NavLink to={`/${language}/`}>
								<img src={mustanadlogo} height="100" alt="Mustanad"/>
							</NavLink>
						</section>
						<section className="rgtpnl">
							<nav className={`inblk vm homnav${menushow ? ' show' : ''}`}>
								<ul>
									<li>
										<NavLink className={({ isActive }) => (isActive ? activeClassName : undefined)} to={`/${language}/`}>
											<span>{t('Home')}</span>
										</NavLink>
									</li>
									<li>
										<NavLink className={({ isActive }) => (isActive ? activeClassName : undefined)} to={`/${language}/about-us`}>
											<span>{t('About us')}</span>
										</NavLink>
									</li>
									<li className="hassub">
										<Button variant="link nobdr" className={pageArray.includes(pageType) ? 'active' : ''} aria-label="Services">
											<span>{t('Services')}</span>
										</Button>
										<div className="submenu">
											<ul>
												<li>
													<NavLink to={`/${language}/services/auditing`} onClick={() => setmenuShow(false)}>
														{t('Auditing')}
													</NavLink>
												</li>
												<li>
													<NavLink to={`/${language}/services/zakat-tax`} onClick={() => setmenuShow(false)}>
														{t('Zakat & Tax')}
													</NavLink>
												</li>
												<li>
													<NavLink to={`/${language}/services/accounting`} onClick={() => setmenuShow(false)}>
														{t('Accounting')}
													</NavLink>
												</li>
												<li>
													<NavLink to={`/${language}/services/local-content-auditing`} onClick={() => setmenuShow(false)}>
														{t('Local content auditing')}
													</NavLink>
												</li>
											</ul>
										</div>
									</li>
									<li>
										<NavLink className={({ isActive }) => (isActive ? activeClassName : undefined)} to={`/${language}/career`}>
											<span>{t('Career')}</span>
										</NavLink>
									</li>
									<li>
										<NavLink className={({ isActive }) => (isActive ? activeClassName : undefined)} to={`/${language}/pricing`}>
											<span>{t('Pricing')}</span>
										</NavLink>
									</li>
									<li>
										<NavLink className={({ isActive }) => (isActive ? activeClassName : undefined)} to={`/${language}/contact-us`}>
											<span>{t('Contact us')}</span>
										</NavLink>
									</li>
								</ul>
							</nav>
							<div className="overlay" onClick={() => setmenuShow(false)}></div>
							<div className="inblk vm lognav">
								<div className="inblk vm mblbtnbx">
									<Button variant="thm2 lh-16 nofcs" onClick={() => setmenuShow(true)} aria-label="Menu">
										<i className="fa-solid fa-bars"></i>
									</Button>
								</div>
								<div className="inblk vm snav">
									{!isLoggedIn ? (
										<NavLink to={`/${language}/sign-in`} className="btn btn-thm2 lh-16 nofcs">
											{t('Sign in')}
										</NavLink>
									) : (
										<NavLink to={redirectLink} className="btn btn-thm2 lh-16 nofcs">
											{t('Dashboard')}
										</NavLink>
									)} 
								</div>
								<div className="inblk vm langswth">
									<Button variant="outline-thm1 lh-16 nofcs" style={{ color: '#444', backgroundColor: 'transparent' }} aria-label="Language">
										<span className="flgspan">
											<img src={'ar' === language ? arbFlag : engFlag} width="100" alt={'ar' === language ? 'Arabic' : 'English'} />
										</span>
										<samp>{'ar' === language ? 'AR' : 'EN'}</samp>
									</Button>
									<div className="drpdwn">
										<section>
											<Button variant="link nofcs" onClick={(e) => languageChange('ar' === language ? 'en' : 'ar')} aria-label="Language">
												<span className="flgspan">
													<img src={'ar' === language ? engFlag : arbFlag} width="100" alt={'ar' === language ? 'English' : 'Arabic'} />
												</span>
												<samp>{'ar' === language ? 'English' : 'Arabic'}</samp>
											</Button>
										</section>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
			</header>
		</>
	);
};

export default HomeHeader;